export default __webpack_public_path__ + "static/media/baby-gray.79cab54f.svg";